/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EnumerationValueDto } from './EnumerationValueDto';
import {
    EnumerationValueDtoFromJSON,
    EnumerationValueDtoFromJSONTyped,
    EnumerationValueDtoToJSON,
} from './EnumerationValueDto';
import type { NumericListDto } from './NumericListDto';
import {
    NumericListDtoFromJSON,
    NumericListDtoFromJSONTyped,
    NumericListDtoToJSON,
} from './NumericListDto';
import type { NumericValueDto } from './NumericValueDto';
import {
    NumericValueDtoFromJSON,
    NumericValueDtoFromJSONTyped,
    NumericValueDtoToJSON,
} from './NumericValueDto';

/**
 * 
 * @export
 * @interface ElectronBeamQualityDto
 */
export interface ElectronBeamQualityDto {
    /**
     * 
     * @type {string}
     * @memberof ElectronBeamQualityDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ElectronBeamQualityDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof ElectronBeamQualityDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ElectronBeamQualityDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ElectronBeamQualityDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ElectronBeamQualityDto
     */
    readonly isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ElectronBeamQualityDto
     */
    readonly deleterUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ElectronBeamQualityDto
     */
    readonly deletionTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElectronBeamQualityDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ElectronBeamQualityDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {NumericListDto}
     * @memberof ElectronBeamQualityDto
     */
    availableDoseRates: NumericListDto;
    /**
     * 
     * @type {EnumerationValueDto}
     * @memberof ElectronBeamQualityDto
     */
    radiationType: EnumerationValueDto;
    /**
     * 
     * @type {NumericValueDto}
     * @memberof ElectronBeamQualityDto
     */
    energy: NumericValueDto;
    /**
     * 
     * @type {EnumerationValueDto}
     * @memberof ElectronBeamQualityDto
     */
    highDoseTechniqueType: EnumerationValueDto;
    /**
     * 
     * @type {string}
     * @memberof ElectronBeamQualityDto
     */
    $type?: ElectronBeamQualityDtoTypeEnum;
}


/**
 * @export
 */
export const ElectronBeamQualityDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedMedicalSystemComponentDtoTreatmentMachinesConfigurationElectronBeamQualityDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.TreatmentMachines.Configuration.ElectronBeamQualityDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ElectronBeamQualityDtoTypeEnum = typeof ElectronBeamQualityDtoTypeEnum[keyof typeof ElectronBeamQualityDtoTypeEnum];


/**
 * Check if a given object implements the ElectronBeamQualityDto interface.
 */
export function instanceOfElectronBeamQualityDto(value?: unknown): value is ElectronBeamQualityDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ElectronBeamQualityDtoTypeEnum)[0];
}

export function ElectronBeamQualityDtoFromJSON(json: any): ElectronBeamQualityDto {
    return ElectronBeamQualityDtoFromJSONTyped(json, false);
}

export function ElectronBeamQualityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ElectronBeamQualityDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'lastModifierUserId': !exists(json, 'lastModifierUserId') ? undefined : json['lastModifierUserId'],
        'isDeleted': !exists(json, 'isDeleted') ? undefined : json['isDeleted'],
        'deleterUserId': !exists(json, 'deleterUserId') ? undefined : json['deleterUserId'],
        'deletionTime': !exists(json, 'deletionTime') ? undefined : json['deletionTime'],
        'name': json['name'],
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'availableDoseRates': NumericListDtoFromJSON(json['availableDoseRates']),
        'radiationType': EnumerationValueDtoFromJSON(json['radiationType']),
        'energy': NumericValueDtoFromJSON(json['energy']),
        'highDoseTechniqueType': EnumerationValueDtoFromJSON(json['highDoseTechniqueType']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function ElectronBeamQualityDtoToJSON(value?: ElectronBeamQualityDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'lastModificationTime': value.lastModificationTime,
        'name': value.name,
        'iuid': value.iuid,
        'availableDoseRates': NumericListDtoToJSON(value.availableDoseRates),
        'radiationType': EnumerationValueDtoToJSON(value.radiationType),
        'energy': NumericValueDtoToJSON(value.energy),
        'highDoseTechniqueType': EnumerationValueDtoToJSON(value.highDoseTechniqueType),
        '$type': value.$type,
    });
}

